
import { throwError as observableThrowError, Observable, of } from 'rxjs';
import { Injectable, Inject, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

import { User } from '@models/user';
import { ErrorResponse } from '@models/error.response';
import { ErrorResponseNode } from '@models/error.response.node';
import swal from 'sweetalert2'
import { switchMap } from 'rxjs/operators';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import {FormGroup, NgForm} from "@angular/forms";
import { ActionType } from '@app/types/action.type';
// import { UserChangePasswordComponent } from '@app/components/user/user-change-password.component';

declare var localStorage: any;
declare var sessionStorage: any;

@Injectable()
export class CommonService {

    currentUser: User;

    userChangeEmitter: EventEmitter<User> = new EventEmitter();

    constructor(
        @Inject(TranslateService) private translate: TranslateService,
        @Inject(Router) private router: Router) {
    }

    public getUserChangeEmitter(): EventEmitter<User> {
        return this.userChangeEmitter;
    }

    public setCurrentToken(token: string): void {
        sessionStorage.etasAdmWebtoken = token;
    }

    public getCurrentToken(): string {
        return sessionStorage.etasAdmWebtoken;
    }

    public setCurrentUser(user: User): void {
        this.currentUser = user;
        sessionStorage.user = JSON.stringify(user);
        this.userChangeEmitter.emit(user);
    }

    public getCurrentUser(): User {
        if (this.currentUser != null) {
            return this.currentUser;
        }

        if (sessionStorage.user == null || sessionStorage.user === '') {
            return null;
        } else {
            this.currentUser = <User>JSON.parse(sessionStorage.user);
            return this.currentUser;
        }
    }

    public getHeaders(): HttpHeaders {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'X-Auth-Token': this.getCurrentToken()
        });
    }

    public getFormHeaders(): HttpHeaders {
        return new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Auth-Token': this.getCurrentToken()
        });
    }

    public setDefaultLang(lang: string) {
        localStorage.lang = lang;
    }

    public getDefaultLang(): string {
        if (localStorage.lang == null) {
            return 'en';
        } else {
            return localStorage.lang;
        }
    }

    public flattenMarket(market: any[]) {
        if (!market || market.length === 0) {
            return [];
        }

        market.forEach(item => {
            market.push(this.flattenMarket(item['children']));
            item['children'] = [];
        });
        return market;
    }

    public handleHttpError(error: HttpErrorResponse | ErrorResponse | any): Observable<any> {
        // In a real world app, we might use a remote logging infrastructure
        console.log('wwg');
        let instance = this;
        if(error.error instanceof Blob){
                var reader=new FileReader();
                reader.readAsText(error.error)
                reader.onload = function() {
                  if (typeof (reader.result) == 'string') {
                    var errInfo = JSON.parse(reader.result); 
                    var ggg = new HttpErrorResponse({error: errInfo, status: 500});
                    return instance.handleHttpError(ggg);
                  }
                }
                return observableThrowError(null);
        }

        let errorResponse: ErrorResponse;
        if (error instanceof ErrorResponse) {
            errorResponse = error;
        }
        if (error instanceof HttpErrorResponse) {

            if (error.status === 0) {
                errorResponse = new ErrorResponse();
                errorResponse.errors = [new ErrorResponseNode('ERR_CONNECTION_ERROR', 'ERR_CONNECTION_ERROR', null)];
            } else if (error.status === 404) {
                errorResponse = new ErrorResponse();
                errorResponse.errors = [new ErrorResponseNode('ERR_RESOURCE_NOT_FOUND', 'ERR_RESOURCE_NOT_FOUND', null)];
            } else {
                let body = error.error;
                if (body != null && body.errors != null) {
                    errorResponse = <ErrorResponse>body;
                } else if(body != null && body.content != null && body.content.errors != null) {
                    errorResponse = <ErrorResponse>(body.content);
                }
            }
        }
        
        if (errorResponse == null) {
            errorResponse = new ErrorResponse();
            errorResponse.errors = [new ErrorResponseNode('ERR_SYS_UNKNOWN', 'ERR_SYS_UNKNOWN', null)];
        }

        if (errorResponse.errors[0].errorCode === 'ERR_SYS_EXPIRED_TOKEN') {
            this.handleTokenExpired();
        }else if (errorResponse.errors[0].errorCode === 'ERR_FORCE_CHANGE_PASSWORD') {
            swal.fire({
                type: 'warning',
                text: "Please Reset Your Passowrd First.",
                confirmButtonText: "OK",
                allowOutsideClick: false
            }).then(function () {
            });
        }else if (errorResponse.errors[0].errorCode.startsWith('SHOW_ERR_') && errorResponse.errors[0].errorMsg) {
            swal.fire({
                type: 'warning',
                text: errorResponse.errors[0].errorMsg,
                confirmButtonText: "OK",
                allowOutsideClick: false
            }).then(function () {
                // window.history.go(-1);
            });
        }else if (errorResponse.errors[0].errorCode=='ERR_SYS_LOCKED_USR'
                 ||errorResponse.errors[0].errorCode=='ERR_SYS_DISABLED_USR'
                 ||errorResponse.errors[0].errorCode=='ERR_SYS_INCORRECT_ID_PW') {

        }else if (errorResponse.errors[0].errorCode == 'ERR_SYS_UNKNOWN' && errorResponse.errors[0].errorMsg) {
            console.error(errorResponse.errors[0].errorMsg);
        }else if (errorResponse.errors[0].errorCode.startsWith('ERR_') && errorResponse.errors[0].errorMsg) {
            swal.fire({
                type: 'warning',
                text: 'System Error. Please contact administrator for more details.',
                confirmButtonText: "OK",
                allowOutsideClick: false
            }).then(function () {
                // window.history.go(-1);
            });
        }
        

        return observableThrowError(errorResponse);

    }

    public handleTokenExpired(): void {
        let instance = this;

        let texts = {
            msg: '',
            btn: ''
        };

        this.translate.get('ERR_SYS_EXPIRED_TOKEN')
            .pipe(
                switchMap(msg => {
                    texts.msg = msg;
                    return this.translate.get('OK');
                }),
                switchMap(lblOk => {
                    texts.btn = lblOk;
                    return of(texts);
                })
            ).subscribe(texts => {
                swal.fire({
                    type: 'error',
                    //    title: 'Fail to add a new presenter',
                    text: texts.msg,
                    confirmButtonText: texts.btn,
                    allowOutsideClick: false
                }).then(function () {
                    sessionStorage.clear();
                    instance.router.navigate(['./login']);
                });
            });
    }

    public hasAuthority(permissions: string | string[]) {
        if (typeof permissions === 'string') {
            permissions = [permissions];
        }

        if (this.getCurrentUser() == null) {
            return false;
        }

        let user: User = this.getCurrentUser();

        for (let permission of permissions) {
            if (user.authorities.find(authority => authority.authority === permission) != null) {
                return true;
            }
        }

        return false;
    }

    public showAddButton(action: ActionType, createAuthority:string):boolean{
        return (action == 'CREATE' && this.hasAuthority(createAuthority));
     }

    public showUpdateButton(action: ActionType, updateAuthority:string):boolean{
        return (action == 'EDIT' && this.hasAuthority(updateAuthority));
     }

    public hasRole(roles: string | string[]) {
        if (typeof roles === 'string') {
            roles = [roles];
        }

        if (this.getCurrentUser() == null) {
            return false;
        }

        for (let roleCode of roles) {
            if (this.getCurrentUser().roles.find(role => role.roleCode === roleCode) != null) {
                return true;
            }
        }

        return false;
    }

    public hasRoleType(roleTypes: string | string[]) {
        if (typeof roleTypes === 'string') {
            roleTypes = [roleTypes];
        }

        if (this.getCurrentUser() == null) {
            return false;
        }

        for (let roleType of roleTypes) {
            if (this.getCurrentUser().roles.find(role => role.type === roleType) != null) {
                return true;
            }
        }

        return false;
    }

  public initialFormStates(form: NgForm | FormGroup) {
    for (const key of Object.keys(form.controls)) {
      form.controls[key].markAsPristine();
      form.controls[key].markAsUntouched();
    }
  }

  
  getParamFromUrl(paramKey: string): string {
    return this.getUrlParam(paramKey,null);
  }
  
  getUrlParam(name:string, defaultVal:string) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); 
    var r = window.location.search.substr(1).match(reg); 
    if (r != null) return unescape(r[2]); return (defaultVal?defaultVal:null); 
}
}
